import { Heading } from '@chakra-ui/react';
import SKCard from 'components/UI/SKCard';
import SKModal from 'components/UI/SkModal';
import React, { useEffect, useState } from 'react';
import classes from './styles.module.scss';
import { ReactComponent as BackIcon } from '../../../../assets/icons/back.svg';
import { ReactComponent as ForwardIcon } from '../../../../assets/icons/forward.svg';
import PhonePeIcon from '../../../../assets/images/phonepe.png';
import GPayIcon from '../../../../assets/images/gpay.png';
import PaytmIcon from '../../../../assets/images/paytm.png';
import AmazonPayIcon from '../../../../assets/images/amazonPay.png';
import OtherUPIIcon from '../../../../assets/images/otherupi.png';
import PHONEPE1 from '../../../../assets/images/PHONEPE1.png';
import PHONEPE2 from '../../../../assets/images/PHONEPE2.png';
import PHONEPE3 from '../../../../assets/images/PHONEPE3.png';
import GPAY1 from '../../../../assets/images/GPAY1.png';
import GPAY2 from '../../../../assets/images/GPAY2.png';
import PAYTM1 from '../../../../assets/images/PAYTM1.png';
import PAYTM2 from '../../../../assets/images/PAYTM2.png';
import AMAZON1 from '../../../../assets/images/AMAZON1.png';
import AMAZON2 from '../../../../assets/images/AMAZON2.png';

import AMZ1 from '../../../../assets/images/AMZ1.png';
import AMZ2 from '../../../../assets/images/AMZ2.png';
import AMZ3 from '../../../../assets/images/AMZ3.png';
import AMZ4 from '../../../../assets/images/AMZ4.png';

import { useNavigate } from 'react-router-dom';
import { PROFILE_PAGE } from 'constants/route.const';
import queryString from 'query-string';
import { useLocation } from 'react-router-dom';

const INFO = [
  {
    title: 'Paytm',
    img: PaytmIcon,
    children: [
      {
        title: 'Open Paytm app and go to the menu on the top left corner.',
        img: PAYTM1,
      },
      {
        title:
          'Copy UPI ID which will be shown on the top side of the opened menu.',
        img: PAYTM2,
      },
    ],
  },
  {
    title: 'Google Pay',
    img: GPayIcon,
    children: [
      {
        title:
          'Open Google Pay app and go to the profile on the top right corner.',
        img: GPAY1,
      },
      {
        title: 'Your UPI ID will be shown on the top of the profile menu.',
        img: GPAY2,
      },
    ],
  },
  {
    title: 'Phone Pe',
    img: PhonePeIcon,
    children: [
      {
        title: 'Open PhonePe app and go to the profile on the top left corner.',
        img: PHONEPE1,
      },
      {
        title: 'Go to My UPI ID section from the list of all the sections.',
        img: PHONEPE2,
      },
      {
        title: 'Press and hold on the UPI ID to copy it.',
        img: PHONEPE3,
      },
    ],
  },
  {
    title: 'Amazon Pay',
    img: AmazonPayIcon,
    children: [
      {
        title: 'Go to Amazon pay from your Amazon app',
        img: AMAZON1,
      },
      {
        title:
          'Swipe on the cards to Amazon Pay UPI and your UPI ID will be displayed on the Amazon Pay UPI card',
        img: AMAZON2,
      },
    ],
  },
  {
    title: 'Other Apps',
    img: OtherUPIIcon,
    children: [
      {
        title: 'Open UPI linked app on your phone and go to your profile',
      },
      {
        title:
          'Your UPI ID will be shown on the profile screen (eg:number@bank)',
      },
      {
        title:
          'Copy your UPI ID and paste it on your Chillar Pro redeem screen',
      },
    ],
  },
];

const AMAZON_INFO = {
  title: 'A',
  children: [
    {
      title: 'Go to your Amazon app and click on Sign In',
      img: AMZ1,
    },
    {
      title: 'Click on create account',
      img: AMZ2,
    },
    {
      title:
        'Fill out the all the fields with your details and then click on verify mobile number and complete your registration.',
      img: AMZ3,
    },
    {
      title:
        'After your account is created, click on Amazon Pay to go to your wallet.',
      img: AMZ4,
    },
  ],
};
export default function UPIInfoModal({ type }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [infoModal, setInfoModal] = useState(false);
  const [currentInfo, setCurrentInfo] = useState(null);

  useEffect(() => {
    const params = queryString.parse(location.search);
    if (params['upi-info'] === 'true') {
      setInfoModal(true);
    } else {
      setInfoModal(false);
      setCurrentInfo(null);
    }
  }, [location.search]);

  function onInfoModalOpen() {
    navigate(PROFILE_PAGE, { search: 'upi-info=true' });
    setInfoModal(true);
  }

  function closeInfoModal() {
    setInfoModal(false);
    navigate(PROFILE_PAGE, { replace: true });
  }

  function onBack() {
    if (currentInfo) {
      setCurrentInfo(null);
      return;
    }
    setInfoModal(false);
    navigate(PROFILE_PAGE, { replace: true });
  }
  function onInfoSelect(d) {
    setCurrentInfo(d);
  }
  const backIcon = (
    <div className={classes.backIcon} onClick={onBack}>
      <BackIcon />
    </div>
  );
  return (
    <>
      <div className={classes.body}>
        {type === 'amazon'
          ? 'How to create Amazon wallet?'
          : 'How to get upi id?'}
        <a onClick={onInfoModalOpen}>Click here</a>
      </div>
      <SKModal isOpen={infoModal} onClose={closeInfoModal} title={backIcon}>
        {type === 'amazon' ? (
          <div className={classes.currentInfo}>
            <Heading as="h4">How to create Amazon wallet?</Heading>
            <div className={classes.list}>
              {AMAZON_INFO.children.map((d, index) => (
                <div key={d.title} className={classes.info}>
                  <div className={classes.number}>{index + 1}</div>
                  <div className={classes.content}>
                    <div className={classes.title}>{d.title}</div>
                    {d.img && <img src={d.img} alt={d.title} />}
                  </div>
                </div>
              ))}
            </div>
          </div>
        ) : currentInfo ? (
          <div className={classes.currentInfo}>
            <Heading as="h4">
              How to find UPI ID inside {currentInfo.title}?
            </Heading>
            <div className={classes.list}>
              {currentInfo.children.map((d, index) => (
                <div key={d.title} className={classes.info}>
                  <div className={classes.number}>{index + 1}</div>
                  <div className={classes.content}>
                    <div className={classes.title}>{d.title}</div>
                    {d.img && <img src={d.img} alt={d.title} />}
                  </div>
                </div>
              ))}
            </div>
          </div>
        ) : (
          <div className={classes.allUpi}>
            <Heading as="h4">How to find UPI ID?</Heading>
            <div className={classes.list}>
              {INFO.map(d => (
                <SKCard
                  key={d.title}
                  className={classes.row}
                  onClick={() => onInfoSelect(d)}
                >
                  <img src={d.img} alt={d.title} />
                  <div className={classes.title}>{d.title}</div>

                  <div className={classes.icon}>
                    <ForwardIcon />
                  </div>
                </SKCard>
              ))}
            </div>
          </div>
        )}
      </SKModal>
    </>
  );
}
